export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      user: {
        userUuid: '1b2c6a69f00ab0ea7583ce9b3c58b4a5',
        name: '運営者 太郎',
        email: 'aaa@aaa.com',
        roleKbn: 2,
        service: {
          serviceUuid: 'サービスUUID',
          serviceName: 'サービス名'
        },
        linkedCmss: [
          {
            linkCMSMstId: 1,
            linkCMSName: '連携CMS名称',
            linkCMSURL: '連携CMS URL'
          }
        ],
        lastLoginAt: 1594880785395,
        mfaConfirmedAt: 1594880785395,
        passwordChanged: false
      },
      accessToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9kZXYuaW5zcGVjdGlvbi5qaXcuY28uanBcL2FwaVwvdjFcL2xvZ2luXC91c2VyIiwiaWF0IjoxNTgzNzMzNjY1LCJleHAiOjE1ODM4MjAwNjUsIm5iZiI6MTU4MzczMzY2NSwianRpIjoiZW51MnliN09pVVpINWZmUyIsInN1YiI6MjcsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjcifQ.1PnsyFSJKU6l3citm1ZOb2OxsbbP9VTaA8Itc_5O28k',
      expireIn: 120,
      timestamp: 1594880785395,
      hash: 'cb8c6079f3dbedcb2fb51e22d926f8c85370d6e6bc94e2dec29c450b7155678e'
    }
  }
}